module.exports = __webpack_public_path__ + "static/img/home-logo.9fe4295a.png";